import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface TextWidgetProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  placeholder?: string;
  helpText?: string;
}

export const TextWidget: React.FC<TextWidgetProps> = ({
  label,
  value,
  onChange,
  error,
  disabled = false,
  required = false,
  description,
  placeholder,
  helpText
}) => {
  return (
    <div className={wt.container}>
      <div className={wt.labelRow}>
        <label className={wt.label}>
          {label}
          {required && <span className={wt.required}>*</span>}
        </label>
        {helpText && <HelpTooltip helpText={helpText} />}
      </div>
      {description && <p className={wt.description}>{description}</p>}
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className={`${wt.input} ${error ? wt.inputError : ''}`}
      />
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default TextWidget;
